import ServicePageTemplate from './ServicePageTemplate';
import { webDesigningCourseModasaConfig } from './trainingPageConfigs';

const WebDesigningCourseModasa = () => <ServicePageTemplate {...webDesigningCourseModasaConfig} />;

export default WebDesigningCourseModasa;